"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _default = (0, _propTypes.shape)({
  breakpoints: (0, _propTypes.arrayOf)(_propTypes.string),
  columns: (0, _propTypes.arrayOf)(_propTypes.number),
  fontSizes: (0, _propTypes.arrayOf)(_propTypes.number),
  fontWeights: (0, _propTypes.arrayOf)(_propTypes.number),
  gutters: (0, _propTypes.arrayOf)(_propTypes.string),
  lineHeights: (0, _propTypes.arrayOf)(_propTypes.number),
  spacings: (0, _propTypes.arrayOf)(_propTypes.number),
  unitPadding: (0, _propTypes.arrayOf)(_propTypes.number)
});

exports["default"] = _default;